import React, { FC, useState } from "react";
import { Form, Select, InputNumber, Button, Space } from "antd";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { ChangeWarehouseStatus } from "../../api/global";
import { handleToWarehouseParams } from "../../helpers/sku.helper";
import { handleSelectExit } from "../../constants/product.constant";
import { useGlobalState } from "../../context/Provider";
import { FormattedMessage } from "react-intl";
import {
  handleTransferParams,
  handleExitParams,
} from "../../helpers/products.helper";

const ProductActionForm: FC = () => {
  const { Option } = Select;
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const { pathname, search }: any = useLocation();
  const fromWarehouse = new URLSearchParams(search).get("w");
  const id = new URLSearchParams(search).get("id");
  const { skuId, type, activeSection }: any = useParams();
  const [params, setParams] = useState({});
  const { langState, warehouserList }: any = useGlobalState();
  const lang = langState.locale;
  const [loading, setLoading] = useState(false);

  const handleSubmit = (value: any) => {
    setLoading(true);
    ChangeWarehouseStatus(type, params).then((res: any) => {
      setLoading(false);
      if (res.status === 200) {
        navigate(`/panel/${activeSection}/acceptanceOfAction/${type}`);
        // type transfer
      }
    });
  };

  const handleFieldChange = (_: any, allFields: any) => {
    const newParams = allFields.map((elem: any) => ({
      [elem.name[0]]: elem.value,
    }));

    switch (type) {
      case "towarehouse":
        {
          const test = { ...newParams[0], ...newParams[1], ...newParams[2] };
          const { type, quantity, warehousName }: any = test;
          setParams(
            handleToWarehouseParams(skuId, type, quantity, warehousName)
          );
        }
        break;
      case "exit":
        {
          const test = { ...newParams[0], ...newParams[1] };
          const { type, quantity }: any = test;

          setParams(handleExitParams(id, type, quantity, fromWarehouse));
        }
        break;
      case "transfer":
        {
          const test = { ...newParams[0], ...newParams[1] };
          const { quantity, warehousName }: any = test;

          setParams(
            handleTransferParams(skuId, quantity, fromWarehouse, warehousName)
          );
        }
        break;
      default: {
      }
    }
  };

  return (
    <Form
      form={form}
      name="towarhouse"
      wrapperCol={{ span: 24 }}
      onFinish={handleSubmit}
      autoComplete="off"
      onFieldsChange={handleFieldChange}
    >
      <Space>
        {type !== "exit" && (
          <Form.Item
            label={lang === "en-US" ? "Destination warehouse" : "انبار مقصد"}
            name="warehousName"
            rules={[
              {
                required: true,
                // message: "Please select your warehous!",
                message:
                  lang === "en-US"
                    ? "Please select your warehous!"
                    : "لطفا انبار مورد نظرتان را انتخاب کنید ",
              },
            ]}
          >
            <Select
              style={{ width: 200 }}
              placeholder={
                lang === "en-US" ? "select to warehouse" : "انتخاب  انبار"
              }
            >
              {warehouserList.data.map((item: any) => (
                <Option value={item.id} key={item.id}>
                  {item.name}
                </Option>
              ))}
            </Select>
          </Form.Item>
        )}

        {type !== "transfer" && (
          <Form.Item
            label={lang === "en-US" ? "type" : "نوع"}
            name="type"
            rules={[
              {
                required: true,
                message:
                  lang === "en-US"
                    ? "Please select your typs!"
                    : "لطفا نوع رو انتخاب کنید ",
              },
            ]}
          >
            <Select
              placeholder={lang === "en-US" ? "select to type" : "انتخاب نوع"}
              style={{ width: 200 }}
              onChange={() => console.log("change")}
            >
              {handleSelectExit.map((item: any) => (
                <Option key={item.value} value={item.value}>
                  {item.label}
                </Option>
              ))}
            </Select>
          </Form.Item>
        )}
      </Space>
      <Form.Item
        label={lang === "en-US" ? "count" : "تعداد"}
        name="quantity"
        rules={[
          {
            required: true,
            message:
              lang === "en-US"
                ? "Please input your coutt!"
                : "لطفا تعداد رو مشخص کنید ",
          },
        ]}
      >
        <InputNumber min={1} max={100000} />
      </Form.Item>
      <div>
        <Form.Item>
          <Button
            loading={loading}
            type="primary"
            htmlType="submit"
            className="w-100 success"
            style={{
              backgroundColor:
                type === "towarehouse"
                  ? "#00C897"
                  : type === "exit"
                  ? "#D82148"
                  : " #1890ff",
              border: "none",
            }}
          >
            {type === "towarehouse" ? (
              <FormattedMessage id="productActionForm.towarehouse.submit" />
            ) : type === "exit" ? (
              <FormattedMessage id="productActionForm.exit.submit" />
            ) : (
              <FormattedMessage id="productActionForm.Transfer.submit" />
            )}
          </Button>
        </Form.Item>
      </div>
    </Form>
  );
};

export default ProductActionForm;
